import Address from './address';
class BillingAddress extends Address {
    constructor(properties) {
        super(properties);
    }
}

export default BillingAddress;
